import request from "@/utils/request";

// 获取数据
export function getData(data) {
    return request({
        url: "match/match/matchNewsList",
        method: "post",
        data
    });
}

// 获取更多新闻
export function getNewsMore(data) {
    return request({
        url: "match/match/moreMatchNewsList",
        method: "post",
        data
    });
}

// 获取更多赛事
export function getSchoolMore(data) {
    return request({
        url: "match/match/moreSchoolNewsList",
        method: "post",
        data
    });
}

// 获取详情
export function getNewsinfo(params) {
    return request({
        url: `/match/match/matchNewsInfo/${params}`,
        method: "get",
    });
}


// WEBPACK FOOTER //
// ./src/api/news.js